import React, {useEffect} from "react";
import {Helmet} from "react-helmet-async";
import {CmmnHeader} from "../components/common/CmmnHeader";
import {Sub_top_002} from "../const/ConstImages";
import ValidCodeBody from "../components/login/ValidCodeBody";

const ValidCodeScreen = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return(
        <>
            <Helmet>
                <title>Valid Code</title>
                <meta name="description" content="PUT VALID CODE" />
            </Helmet>
            <CmmnHeader backgroundImg={Sub_top_002} title="Valid Code" />
            <ValidCodeBody />
        </>
    );
}
export default ValidCodeScreen;